import React from "react";

const TextIcon = () => (
  <svg width="22" height="26" viewBox="0 0 34 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="2" width="30" height="9" rx="4.5" fill="#E64C9D" />
    <rect x="12.5" y="2" width="9" height="38" rx="4.5" fill="#E64C9D" />
  </svg>
);

const ArrowIcon = () => (
  <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 8H14M14 8L9 3M14 8L9 13" stroke="#FFFFFF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* Exact wave background (same Rectangle used for Photo/Video Advertisement) — wrapped so CSS
   handles the rounded top corners cleanly (the SVG's own corner curve gets distorted when stretched) */
const CardBackground = () => (
  <div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "56px",
      overflow: "hidden",
      borderTopLeftRadius: "20px",
      borderTopRightRadius: "20px",
      zIndex: 0,
    }}
  >
    <svg
      viewBox="0 0 337 43"
      preserveAspectRatio="none"
      style={{ display: "block", width: "100%", height: "100%" }}
    >
      <path
        d="M0 0H337V33.1617C300.647 26.484 268.833 7.27333 201.414 33.1617C164.079 47.498 0 41.9398 0 41.9398V0Z"
        fill="#F3D0E6"
      />
    </svg>
  </div>
);

const styles = {
  outer: {
    position: "relative",
    width: "100%",
    maxWidth: "460px",
    borderRadius: "20px",
    overflow: "hidden",
    background: "#C48CB0",
    boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
    fontFamily: "inherit",
    padding: "0 0 12px 0",
    height: "155px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  header: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 16px 4px 16px",
  },
  headerLeft: { display: "flex", alignItems: "center", gap: "8px" },
  title: { fontSize: "18px", fontWeight: 700, color: "#1E1E1E", margin: 0 },
  badge: {
    background: "#151515",
    color: "#FF3D9A",
    fontSize: "12px",
    fontWeight: 700,
    borderRadius: "8px",
    padding: "4px 12px",
    minWidth: "26px",
    textAlign: "center",
  },
  body: {
    position: "relative",
    zIndex: 2,
    padding: "4px 16px 0 16px",
  },
  bodyText: {
    fontSize: "12.5px",
    fontWeight: 500,
    color: "#1E1E1E",
    lineHeight: 1.4,
    margin: 0,
  },
  viewAll: {
    marginTop: "8px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "13.5px",
    fontWeight: 700,
    color: "#FFFFFF",
    cursor: "pointer",
    background: "none",
    border: "none",
    padding: 0,
  },
};

const TextAdvertisement = ({
  title = "Text Advertisement",
  count = "09",
  message = "Promote your offers and videos on here",
  onViewAll,
}) => {
  return (
    <div style={styles.outer}>
      <CardBackground />

      <div style={styles.header}>
        <div style={styles.headerLeft}>
          <TextIcon />
          <p style={styles.title}>{title}</p>
        </div>
        <span style={styles.badge}>{count}</span>
      </div>

      <div style={styles.body}>
        <p style={styles.bodyText}>{message}</p>
        <button style={styles.viewAll} onClick={onViewAll}>
          View all <ArrowIcon />
        </button>
      </div>
    </div>
  );
};

export default TextAdvertisement;